import React from 'react';
import StrumentoPageTemplate from '../../components/template-strumento';
import { getProp, getPropAsset, getPropMarked } from '../utils';

const StrumentoPreview = (props) => {
  const title = getProp(props, 'title');
  const text = getPropMarked(props, 'text');
  const image = getPropAsset(props, 'image');

  return <StrumentoPageTemplate {...{ title, text, image }} />;
};

export default StrumentoPreview;
